import { instance } from './instance';
import store from '@/store';
import qs from 'qs';

import { ApiRole, returnRole } from './role';

import router from '@/router/index'



const returnKey: returnRole = {
    code: 200,
    Code: 200,
    successful: true
}

class RequestData{
    params?:any
    data?:any
    headers?:any
}


const getRequestUrl = (option:any) => {
    let path = '';
    switch(option.portType) {
        default:
            path += '/api/';
            break;
    }

    if(option.isUseUrl){
        return option.url
    }else{
        return store.state.config.host + store.state.config.gateWay[option.portType ] + path + option.url
    }
    
}
const resolveResponseData = (data:any) => {
    let isSuccess: boolean = false;
    for(const v in returnKey) {
        if(returnKey[v] == data[v]) {
            isSuccess = true;
            break;
        }
    }
    if(isSuccess) {
        let res = data.data || data.Data
        if(data.pageCount !== undefined) {
            return {
                pageCount:data.pageCount, 
                total:data.total, 
                items: res
            }
        }else {
            return res
        }
    }else {
        return data
    }
}
export const getData = (option: ApiRole) => {
    option.requestType = option.requestType ? option.requestType : ''
    let url = getRequestUrl(option);

    let requestData = new RequestData();
    switch(option.type) {
        case 'get':
            requestData.params = option.data
        break;
        case 'post':
            if(option.postUrl){
                let params = '?';
                for(const v in option.data) {
                    params += v + '=' + option.data[v] + '&'
                }
                params = params.slice(0, params.length - 1);
                url += params
            }else if(option.requestType === 'mutilForm') {
                requestData.data = option.data
                requestData.headers = {
                    "Content-Type": 'multipart/form-data; charset=UTF-8'
                }
            }else if(option.requestType === 'wwwForm') {
                requestData.data = qs.stringify(option.data)
                requestData.headers = {
                    "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }else {
            requestData.data = JSON.stringify(option.data)
                requestData.headers = {
                    "Content-Type": 'application/json; charset=UTF-8'
                }
            }
            break;
    }

    if(option.isremoveToken){
        requestData.headers = Object.assign({}, requestData.headers, {
            // Authorization:  `Bearer `,
            organization: store.state.organization,
        }, option.header)
    }else{
        requestData.headers = Object.assign({}, requestData.headers, {
            Authorization:  `Bearer ${store.state.accessToken  }`,
            organization: store.state.organization,
        }, option.header)
        
    }


    
    return new Promise((res,rej): void => {
        instance(url, {
            method: option.type,
            ...requestData
        }).then(async (data: any) => {
            if(data.status == 200) {
                try {
                    data = JSON.parse(data.data)
                } catch (error) {
                    
                }
                
                let isSuccess = false;
                for(const v in returnKey) {
                    if(returnKey[v] == data[v] || option.portType == 'selfConfig') {

                        isSuccess = true;
                        break;
                    }
                }
                if(isSuccess) {
                    res(resolveResponseData(data));
                }else {
                    if(data.code === 'I000007'){
                        store.commit('setAccessToken', '');
                        router.push({name:'login'})
                        rej(data)
                    }else{
                        rej(data)

                    }
                }
            }else {
                rej(data)
                // router.push({name:'login'})
            }
        }).catch(async err => {
            rej(err)
            // console.log(err)
            // router.push({name:'login'})
        })
    })
}